import { useMemo } from 'react';
import { WizardContainer } from '../../../components/wizard/Wizard';
import { WizardProvider } from '../../../components/wizard/useWizard';
import { PreWorkStep } from './PreWorkStep';
import { PreWorkProvider, usePreWorkWizard } from './usePreWorkWizard';
import { PRE_WORK_CONTEXT } from '../../../shared/Routes';

export const PreWorkWizard = () => {
	const { onSubmitClick, onCancelClick } = usePreWorkWizard();
	const currentWizard = 0;
	const wizards = useMemo(
		() => [
			{
				steps: [<PreWorkStep key={1} />],
			},
		],
		[]
	);
	const steps = wizards[currentWizard].steps;

	return (
		<div className="flex flex-col h-full min-h-0 p-[8px]">
			<WizardContainer
				onSubmitClick={onSubmitClick}
				onCancelClick={onCancelClick}
				steps={steps}
				navigateTo={PRE_WORK_CONTEXT}
			/>
		</div>
	);
};

export const PreWorkWizardContainer = () => {
	return (
		<PreWorkProvider>
			<WizardProvider>
				<PreWorkWizard />
			</WizardProvider>
		</PreWorkProvider>
	);
};
